/* eslint-disable no-unused-vars */
const Autodesk = window.Autodesk;
import store from '@/store';
import { getAllParentsIds } from '@/utils/forgeUtils'
import { getAMISInspectionTagsByIds } from '@/utils/amisAPIs'
import { log as debugLog, warn as debugWarn, error as debugError } from '@/utils/debugLogger';

class CustomContextMenuExtension extends Autodesk.Viewing.Extension {
    constructor(viewer, options) {
        super(viewer, options);
        this.viewer = viewer;
        this.contextMenu = viewer.contextMenu;
        this.location = null;
    }

    load() {
        this.viewer.canvas.addEventListener("dblclick", this.handleDoubleClick);

        return true;
    }

    unload() {
        this.viewer.canvas.removeEventListener("dblclick", this.handleDoubleClick);
        return true;
    }

    handleDoubleClick = (event) => {
        if (event.which !== 1) return false;
        this.selectionHandler(event);
    }

    selectionHandler = (event) => {        
        let selection = this.viewer.model.selector.getSelection();
        
        // To handle selected elements right click event only.
        if (!selection.length) {
            // this.viewer.setContextMenu(this.contextMenu);
            return;
        }

        this.location = { clientX: event.clientX, clientY: event.clientY }
        let dbId = selection[0];
        let dbIds = [dbId, ...getAllParentsIds(this.viewer, dbId)];
        let { showEquipmentPopup, showInspectionPopup, showAnnotationPopup, showPipelinePopup, showStructuralPopup } = store.state.userSettings.displaySettings;
        let typesToLoad = {
            'Equipments': showEquipmentPopup,
            'Structural': showStructuralPopup,
            'Pipelines': showPipelinePopup,
            'Inspections': showInspectionPopup,
            'Annotations': showAnnotationPopup,
            'Anomalies': true,
            'AvaInspect': true
        }
        this.getPopupData(dbIds, typesToLoad).then((tags) => {
            if (tags.length) {
                store.state.forgeService.showListOfThumbnails(tags, event, '3d');
                // this.viewer.setContextMenu(null);
            } else {
                // this.viewer.setContextMenu(this.contextMenu);
            }
            return;
        })   

        // this.viewer.setContextMenu(null);
    }

    // {clientX: xxx, clientY: xxx}
    showForgeContextMenu = () => {
        store.commit('hideThumbnailPopup', '3d');
        this.viewer.setContextMenu(this.contextMenu);
        this.viewer.contextMenu.show(this.location)
    }

    // TODO: Refactor this function and call the API to get the 3dObjects with this DBIds then return the tags.
    getPopupData = (dbIds, typesToLoad) => {
        return new Promise((resolve, reject) => {
            let inspectionsPromise = typesToLoad['Inspections'] ? this.getInspectionsForDbIds(dbIds) : Promise.resolve([]);
            let equipmentsPromise = typesToLoad['Equipments'] ? this.getEquipmentTagsForDbIds(dbIds) : Promise.resolve([]);
            let structuralPromise = typesToLoad['Structural'] ? this.getStructuralTagsForDbIds(dbIds) : Promise.resolve([]);
            let pipelinesPromise = typesToLoad['Pipelines'] ? this.getPipelinesTagsForDbIds(dbIds) : Promise.resolve([]);
            let annotationsPromise = typesToLoad['Annotations'] ? this.getAnnotationsForDbIds(dbIds) : Promise.resolve([]);
            let anomalyPromise = typesToLoad['Anomalies'] ? this.getAnomalyTagsForDbIds(dbIds) : Promise.resolve([]);
            let avaInspectPromise = typesToLoad['AvaInspect'] ? this.getAvaInspectTagsForDbIds(dbIds) : Promise.resolve([]);

            Promise.all([inspectionsPromise, equipmentsPromise, structuralPromise, pipelinesPromise, annotationsPromise, anomalyPromise, avaInspectPromise])
                .then(([inspections, equipments, structural, pipelines, annotations, anomalies, avaInspect]) => {
                    resolve([...equipments, ...structural, ...pipelines, ...inspections, ...annotations, ...anomalies, ...avaInspect]);
                })
                .catch(reject);
        });
    };
    
    getPopupData2 = (dbIds, typesToLoad) => {
        return new Promise((resolve, reject) => {
            let pending = Object.values(typesToLoad).filter(t => t).length;

            let inspections = [];
            let annotations = [];
            let equipments = [];
            let structural = [];
            let pipelines = [];

            if (pending == 0) resolve([]); 

            if (typesToLoad['Inspections']) {
                this.getInspectionsForDbIds(dbIds)
                    .then(tags => {
                        inspections = tags ?? [];
                    })
                    .finally(_ => {
                        pending--;

                        if (pending === 0) resolve([...equipments, ...structural, ...pipelines, ...inspections, ...annotations]);
                    });
            }

            if (typesToLoad['Equipments']) {
                this.getEquipmentTagsForDbIds(dbIds)
                    .then(tags => {
                        equipments = tags ?? [];
                    }).finally(_ => {
                        pending--;

                        if (pending === 0) resolve([...equipments, ...structural, ...pipelines, ...inspections, ...annotations]);
                    });
            }

            if (typesToLoad['Structural']) {
                this.getStructuralTagsForDbIds(dbIds)
                    .then(tags => {
                        structural = tags ?? [];
                    }).finally(_ => {
                        pending--;

                        if (pending === 0) resolve([...equipments, ...structural, ...pipelines, ...inspections, ...annotations]);
                    });
            }

            if (typesToLoad['Pipelines']) {
                this.getPipelinesTagsForDbIds(dbIds)
                    .then(tags => {
                        structural = tags ?? [];
                    }).finally(_ => {
                        pending--;

                        if (pending === 0) resolve([...equipments, ...structural, ...pipelines, ...inspections, ...annotations]);
                    });
            }

            if (typesToLoad['Annotations']) {
                this.getAnnotationsForDbIds(dbIds)
                    .then(tags => {
                        annotations = tags ?? [];
                    }).finally(_ => {
                        pending--;

                        if (pending === 0) resolve([...equipments, ...structural, ...pipelines, ...inspections, ...annotations]);
                    });
            }

        })
    }
    getInspectionsForDbIds = (dbIds) => {
        return new Promise((resolve, reject) => {
            let inspections = store.state.inspections.filter(i => i.children?.length && i.children.some(c => dbIds.includes(c.dbId)));

            if (inspections.length) return resolve(inspections);
                
            const set = store.getters.GET_ALL_AMIS_TAGS_IDS;

            const ids = set.filter(t => t.children.some(c => dbIds.includes(c.dbId))).map(t => t.id) ?? [];

            if (!ids.length) return resolve([]);
            
            getAMISInspectionTagsByIds(ids).then(tags => resolve(tags)).catch(error => reject(error))
        })
    }
    getAutomaticTagsForDbIds = (dbIds) => {
        if (Array.isArray(dbIds) && !dbIds.length) return Promise.resolve([]);

        if (!Array.isArray(dbIds)) dbIds = [dbIds];

        return new Promise((resolve, reject) => {
            let tags = store.state.tags.filter(i => i.children?.length && i.children.some(c => dbIds.includes(c.dbId)));
            
            if (tags.length) return resolve(tags);

            let ids = store.state.TAGS.allExistingAutomaticDbids.filter(t => t.children.some(c => dbIds.includes(c.dbId))).map(t => t.id);

            if (!ids.length) return resolve([]);
            
            store.state.forgeService.getAutomaticTagsByIds(ids).then(tags => resolve(tags)).catch(error => reject(error))
        })
    }
    getEquipmentTagsForDbIds = (dbIds) => {
        if (Array.isArray(dbIds) && !dbIds.length) return Promise.resolve([]);

        if (!Array.isArray(dbIds)) dbIds = [dbIds];

        return new Promise((resolve, reject) => {

            let harvestedIds = store.state.TAGS.allExistingAutomaticDbids.filter(t => t.children.some(c => dbIds.includes(c.dbId))).map(t => t.id);

            let manualIds = store.state.tags.filter(i => i.children?.length && i.children.some(c => dbIds.includes(c.dbId))).map(t => t.id);

            const ids = [...harvestedIds, ...manualIds];

            if (!ids.length) return resolve([]);

            store.dispatch('GET_EQUIPMENT_TAGS_BY_IDS', { ids }).then(tags => resolve(tags)).catch(error => reject(error));
        });
    };
    getStructuralTagsForDbIds = (dbIds) => {
        if (Array.isArray(dbIds) && !dbIds.length) return Promise.resolve([]);

        if (!Array.isArray(dbIds)) dbIds = [dbIds];

        let ids = store.getters.GET_ALL_EXISTING_STRUCTURAL_TAGS.filter(t => t.children.some(c => dbIds.includes(c.dbId))).map(t => t.id);

        let manualStructural = store.getters.GET_MANUAL_STRUCTURAL_TAGS.filter(t => t.children.some(c => dbIds.includes(c.dbId))).map(t => t.id) ?? [];

        ids = [...ids, ...manualStructural];

        if (!ids.length) return Promise.resolve([]);

        return store.dispatch('GET_STRUCTURAL_TAGS_BY_IDS', { ids });
    }
    getPipelinesTagsForDbIds = (dbIds) => {
        if (Array.isArray(dbIds) && !dbIds.length) return Promise.resolve([]);

        if (!Array.isArray(dbIds)) dbIds = [dbIds];

        let ids = store.getters.GET_ALL_EXISTING_PIPELINES_TAGS.filter(t => t.children.some(c => dbIds.includes(c.dbId))).map(t => t.id);

        let manualPipelines = store.getters.GET_MANUAL_PIPELINES_TAGS.filter(t => t.children.some(c => dbIds.includes(c.dbId))).map(t => t.id) ?? [];

        ids = [...ids, ...manualPipelines];

        if (!ids.length) return Promise.resolve([]);

        return store.dispatch('GET_PIPELINES_TAGS_BY_IDS', { ids });
    }
    getAnomalyTagsForDbIds = (dbIds) => {
        let ids = store.getters.GET_ALL_EXISTING_ANOMALIES_TAGS.filter(t => t.children.some(c => dbIds.includes(c.dbId))).map(t => t.id);

        if (!ids.length) return Promise.resolve([]);

        return store.dispatch('GET_ANOMALIES_TAGS_BY_IDS', { ids });
    }
    getAvaInspectTagsForDbIds = (dbIds) => {
        if (Array.isArray(dbIds) && !dbIds.length) return Promise.resolve([]);

        if (!Array.isArray(dbIds)) dbIds = [dbIds];

        let tags = store.getters.GET_AVA_INSPECT_TAGS.filter(t => t.children?.length && t.children.some(c => dbIds.includes(c.dbId)));

        if (!tags.length) return Promise.resolve([]);

        let ids = tags.map(t => t.id);

        return store.dispatch('FETCH_AVA_INSPECT_TAG_BY_ID', { ids });
    }
    getAnnotationsForDbIds = (dbIds) => {
        return new Promise((resolve, reject) => {
            try {
                let annotations = store.state.annotations.filter(annotation => annotation.children && annotation.children.length && annotation.children.some(c => dbIds.includes(c.dbId)));
                resolve(annotations);
            } catch (error) {
                debugError('CustomContextMenuExtension', 'Error getting annotations for dbIds', error);
                reject(error);
            }
        })
    }
}

Autodesk.Viewing.theExtensionManager.registerExtension('CustomContextMenuExtension', CustomContextMenuExtension);